var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.user)?_c('div',[_c('v-btn',{attrs:{"type":"button","color":"secondary"},on:{"click":function($event){return _vm.logout()}}},[_vm._v("Logout")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }